import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Helmet } from "react-helmet-async";
import { getDoctor, loadDoctorProfileByUsername } from '../../../store/doctor'
import { getMisc, loadConstant,loadBlog } from '../../../store/misc'
import Footer from '../../home/footer'
import Header from '../../home/header'
import imgTick from '../../../include/images/img-tick.svg'
import locationImg from '../../../include/images/location-icon.svg'
import awLogo from '../../../include/images/award-logo.svg'
import logo from '../../../include/images/yes-mindy-color-logo-small.png'
import { toast } from 'react-toastify'
import AlertError from '../../common/alertError'
import moment from 'moment'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import copyImg from '../../../include/images/feather-copy.svg'
import OrderReview from '../../patient/doctor/appointment/orderReview'
import LoadingBar from 'react-top-loading-bar'
import crossIcon from '../../../include/images/cross.svg'
import TypeSwitch from './../../patient/doctor/appointment/typeSwitch'
import DateTimeSelection from './../../patient/doctor/appointment/dateTimeSelection'
import {
  createOrder,
  getAppointment,
  loadDate,
  loadSlot,
  rescheduleAppointment,
  updateOrder,
  setAppointmentObjData,
  clearSlot,
} from '../../../store/appointment'
import PostAppointment from '../../patient/dashboard/postAppointment'

import arrowtr from './../../../include/images/arrow-tr.svg'
import {
  checkActiveClinicAppointment,
  getPatient,
  loadPatientProfile,
  setShowSuccessData,
} from '../../../store/patient'
import { Link } from 'react-router-dom'
import AlertSuccess from '../../common/alertSuccess'
import { WatiScript } from '../../../include/js/wati'
import VideoOverlay from './videoOverlay'
import Blog from '../../home/common/blog'
import { getFeedback, loadProfileFeedback } from '../../../store/feedback';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import ExistingAppointment from '../../patient/doctor/appointment/existingAppointment';
import ShareProfile from '../../common/shareProfile';

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
const ref = React.createRef(null)

class Profile extends Component {
  state = {
    patient: localStorage.getItem('patient')
      ? JSON.parse(localStorage.getItem('patient'))
      : false,

    page: 1,
    doctorProfile: 0,
    selectedClinic: '',
    selectedDate: '',
    selectedTime: '',
    selectedDuration: '',
    preview: false,
    loading: false,
    orderDetail: {},
    apType: 'clinic',
    sideBar: '',
    Psychiatrist: '',
    Psychologist: '',
    appointId: '',
    loadingPage: false,
    showFeedbackModal: false,
    selectedFeedback: null,
    hasAppointment: false,
    activeClinicAppointment: null,
    isRescheduling: false,
    showShareModal: false,
  }

  onBook = e => {
    e.preventDefault()
    localStorage.setItem('redirectProfile', this.props.location.pathname)
    this.props.history.push(
      'patient/appointment/sign-in/' + this.props.match.params.username
    )
  }

  componentDidUpdate = (prevProps, prevState) => {
  //   if (
  //     !this.props.getPatient.loading &&
  //     this.props.getPatient.loading !== prevProps.getPatient.loading
  //   ) {
  //     const { Psychologist, Psychiatrist } = this.props.getPatient.profile;
  //     this.setState({ Psychologist, Psychiatrist }, () =>
  //       this.props.loadDoctor(this.arrangeParam())
  //     );
  //   }
  const previewPersisted = localStorage.getItem('skipAppointmentModal') === 'true';

    if (previewPersisted && this.state.preview) {
      // console.log("previewPersisted --------->")
      this.setState({
        preview: false,
        sideBar: '',
        orderDetail: {},
      }, () => {
        document.body.classList.remove('toggled-tab');
      });

      localStorage.removeItem('skipAppointmentModal');
    }
    const currentDoctorId = this.props.getDoctor?.profile?._id;
    const prevDoctorId = prevProps.getDoctor?.profile?._id;

    if (currentDoctorId && currentDoctorId !== prevDoctorId) {
      this.props.loadProfileFeedback(currentDoctorId)
    }
  };

  payNow = e => {
    e.preventDefault()
    if (this.state.apType === 'clinic') {
      const payLoad = {
        appointment_time: this.state.selectedTime,
        duration: this.state.selectedDuration,
        doctor_id: this.props.getDoctor.profile._id,
        type: this.state.apType,
        clinic_type: this.state.selectedClinic,
      }

      this.props.createOrder(payLoad, this.callBackOrderLogin)
    } else {
      const res = this.state.orderDetail
      const patientData = JSON.parse(localStorage.getItem('patient'))
      var options = {
        key: process.env.REACT_APP_REZORPAY,
        amount: res.rpay.amount_due * 100,
        currency: 'INR',
        name: 'YesMindy',
        description: 'Appointment',
        image:
          process.env.REACT_APP_S3URL +
          'website/yes-mindy-color-logo-small.png',
        order_id: res.rpay.id,
        handler: response => {
          this.props.updateOrder(
            { payment_info: response },
            this.callBackPayment
          )
          console.log('paymentsuccess', response)
        },
        prefill: {
          name: patientData.first_name + ' ' + patientData.last_name,
          email: patientData.email,
          contact: patientData.mobile,
        },
        notes: {
          address: 'Appointment',
        },
        theme: {
          color: '#621ac0',
        },
      }
      var rzp1 = new window.Razorpay(options)
      rzp1.on('payment.failed', function (response) {
        console.log('paymentfailed', response)
      })
      rzp1.open()
    }
  }
  callBackPayment = res => {
    this.props.loadPatientProfile()
    const { patient } = this.state
    patient[this.props.getDoctor.profile.field_type.name] =
      this.props.getDoctor.profile._id
    localStorage.setItem('patient', JSON.stringify(patient))
    this.props.loadPatientProfile()
    this.removeBodyClass()
    if (res.status === 200) {
      this.props.setShowSuccessData(true)
      //this.props.history.push('/patient/appointment-success')
      localStorage.setItem('skipAppointmentModal', 'true')
      this.props.history.push('/patient/dashboard')
    } else {
      toast(<AlertError message={'Something went wrong.'} />)
    }
  }
  callBackReschedule = res => {
    if (res.status === 200) {
      toast(<AlertSuccess message={'Successfully rescheduled.'} />)
      this.props.history.push('/patient/dashboard')
    } else {
      toast(<AlertError message={res.error} />)
    }
  }

  doSubmit = type => {
    this.setState({ loading: true })
    this.type = type

    if (!this.state.patient) {
      const data = {
        selectedTime: this.state.selectedTime,
        duration: this.state.selectedDuration,
        type,
      }

      if (type === "clinic") {
        data.clinic_type = this.state.selectedClinic
      }

      this.props.setAppointmentObjData(data)
      localStorage.setItem('redirectProfile', this.props.location.pathname)
      this.props.history.push(
        '/patient/appointment/sign-in/' + this.props.match.params.username
      )
    } else {
      if (this.state.appointId) {
        const payLoad = {
          appointment_time: this.state.selectedTime,
        }
        // console.log("reschedule called --------------->")
        this.props.rescheduleAppointment(
          this.state.appointId,
          payLoad,
          this.callBackReschedule
        )
      } else {
        if (type === 'clinic') {
          this.props.checkActiveClinicAppointment(
            this.state.patient._id,
            this.props.getDoctor.profile._id,
            this.appointCheckCallback2
          )
        } else {
          // console.log("else online  ----------->")
          const payLoad = {
            appointment_time: this.state.selectedTime,
            duration: this.state.selectedDuration,
            doctor_id: this.props.getDoctor.profile._id,
            type: type,
          }

          this.props.createOrder(payLoad, this.callBackOrder)
        }
      }
    }
  }

  changeTime = time => {
    this.setState({ selectedTime: time })
  }
  changeClinic = clinic => {
    this.setState({ selectedClinic: clinic, selectedDate: '', selectedDuration: '', selectedTime: '' })
    this.props.clearSlot();  
  }
  changeDuration = duration => {
    this.setState({ selectedDuration: duration, selectedTime: '' })
    this.props.loadSlot(this.props.getDoctor.profile._id, this.state.selectedDate, this.state.apType, duration, this.state.selectedClinic)
  }
  selectDate = (type, date) => {
    this.setState({ selectedDate: date, selectedTime: '' })
    this.props.loadSlot(this.props.getDoctor.profile._id, date, type, this.state.selectedDuration, this.state.selectedClinic)
  }
  removeBodyClass = e => {
    if (e) e.preventDefault()
    document.body.className = 'p-0'
  }
  changeSwitch = type => {
    this.setState({ apType: type, selectedDate: '', selectedDuration: '', selectedTime: '', selectedClinic: '' })
  }

  changeBodyClass = (e, nameClass) => {
    if (e) e.preventDefault()
    this.setState({ selectedDate: '', selectedTime: '', preview: false })
    document.body.classList.add(nameClass)
    this.props.loadDate()
  }

  componentDidMount = () => {
      
    this.props.loadBlog({ published: true });
    if (this.state.patient) {
      this.setState({ loadingPage: true })
      this.props.loadPatientProfile(this.callBackPatient)
    }
    if (this.props.history.location.appointId) {
      this.setState(
        {
          apType: this.props.history.location.appointment_type,
          selectedDuration: this.props.history.location.duration,
          selectedClinic: this.props.history.location.clinic_type,
          sideBar: 'appointment',
          appointId: this.props.history.location.appointId,
        },
        () => {
          this.changeBodyClass(null, 'toggled-tab')
        }
      )
    }

    const { Psychologist, Psychiatrist } = this.state.patient
    this.setState({ Psychologist, Psychiatrist })
    // console.log("this.state.preview After-After ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~>",this.state)
    this.props.loadConstant()
    this.props.loadDoctorProfileByUsername(this.props.match.params.username)
  }

  callBackPatient = res => {
    if (res.data) {
      const patientData =
        this.props.getDoctor?.profile?.field_type?.name === 'Psychologist'
          ? res.data?.psychologist
          : res.data?.psychiatrist

        this.patientData = patientData;
      // console.log('patientData----->', patientData)
      if(this.props.getAppointment.appointmentObj.type === 'clinic') {
        // console.log("calling--->")
        this.props.checkActiveClinicAppointment(
          this.state.patient._id,
          this.props.getDoctor.profile._id,
          this.appointCheckCallback1
        )
        return;
      }
      this.continueBooking(patientData);
    }
  }

  continueBooking = (patientData) => {
    if (
      this.props.getAppointment.appointmentObj.selectedTime &&
      (patientData._id === this.props.getDoctor.profile._id ||
        !patientData?._id)
    ) {
      if (
        this.props.getAppointment.appointmentObj.type === 'clinic' &&
        !this.state.hasAppointment
      ) {
        const schedule = this.props.getDoctor.profile.schedules;
        const duration = this.props.getAppointment.appointmentObj.duration;
        const clinicType = this.props.getAppointment.appointmentObj.clinic_type;
        const isSlot2 = schedule.time2 && duration === schedule.time2;

        let selectedFee =
          clinicType === 2
            ? (isSlot2 ? schedule.clinic2FeeSlot2 : schedule.clinic2Fee)
            : (isSlot2 ? schedule.clinicFeeSlot2 : schedule.clinicFee);
        // console.log("selectedFee 2 : ",selectedFee)
        this.setState(
          {
            loadingPage: false,
            preview: true,
            loading: false,
            apType: this.props.getAppointment.appointmentObj.type,              
            selectedClinic: this.props.getAppointment.appointmentObj.clinic_type,              
            selectedTime:
              this.props.getAppointment.appointmentObj.selectedTime,
            selectedDate: this.props.getAppointment.appointmentObj.selectedTime.split("T")[0],
            selectedDuration: this.props.getAppointment.appointmentObj.duration,
            orderDetail: {
              ret: {
                appointment_time:
                  this.props.getAppointment.appointmentObj.selectedTime,
                duration: 
                  this.props.getAppointment.appointmentObj.duration,
                appointment_type: 'clinic',
                clinic_type: 
                  this.props.getAppointment.appointmentObj.clinic_type,
                consultation_charges: Number(selectedFee),
              },
            },
            sideBar: 'appointment',
          },
          () => {
            document.body.classList.add('toggled-tab')
          }
        )
        this.props.loadSlot(this.props.getDoctor.profile._id, this.state.selectedDate, this.state.apType, this.state.selectedDuration, this.state.selectedClinic)
      } 
      else {
          this.setState(
          {
            apType: this.props.getAppointment.appointmentObj.type,
            selectedTime:
              this.props.getAppointment.appointmentObj.selectedTime,
            selectedDate: this.props.getAppointment.appointmentObj.selectedTime.split("T")[0],
            selectedDuration: this.props.getAppointment.appointmentObj.duration,
          })
        this.props.loadSlot(this.props.getDoctor.profile._id, this.state.selectedDate, this.state.apType, this.state.selectedDuration, this.state.selectedClinic)
        
        const payLoad = {
          appointment_time:
            this.props.getAppointment.appointmentObj.selectedTime,
          duration:
            this.props.getAppointment.appointmentObj.duration,
          doctor_id: this.props.getDoctor.profile._id,
          type: this.props.getAppointment.appointmentObj.type,
        }
      // console.log("payload : ", payLoad)
        this.props.createOrder(payLoad, this.callBackOrderLogin)
      }
    } else {
      this.setState({
        loadingPage: false,
        sideBar: 'appointment',
      })
    }
  }

  appointCheckCallback1 = (res) => {
    console.log(res);
    if (
      res.data?.hasAppointment &&
      (this.patientData._id === this.props.getDoctor.profile._id)   
    ) {
      console.log("inside callback--->")
      this.setState({
          hasAppointment: true,
          activeClinicAppointment: res.data.appointment,
          loadingPage: false,
          sideBar: 'appointment',
      });
    } else {
      console.log("inside else block")
      this.continueBooking(this.patientData);
    }
  }

  handleReschedule = () => {
    const appointment = this.state.activeClinicAppointment;
    this.props.clearSlot();  
    this.setState({
        preview: false,
        sideBar: "appointment",
        isRescheduling: true,

        apType: appointment.appointment_type,
        selectedClinic: appointment.clinic_type,
        selectedDuration: appointment.duration,
        // selectedDate: moment(appointment.appointment_time).format("YYYY-MM-DD"),
        // selectedTime: appointment.appointment_time,
        appointId: appointment._id,
    },
      () => {
        document.body.classList.add('toggled-tab')
      }
    )
  };

  appointCheckCallback2 = (res) => {
    if (res.data.hasAppointment) {
      this.setState({
          hasAppointment: true,
          activeClinicAppointment: res.data.appointment,
          loading: false,
      })

    } else {
      const schedule = this.props.getDoctor.profile.schedules;
      const duration = this.state.selectedDuration;
      const clinicType = this.state.selectedClinic;

      const isSlot2 = schedule.time2 && duration === schedule.time2;

      let selectedFee =
        clinicType === 2
          ? (isSlot2 ? schedule.clinic2FeeSlot2 : schedule.clinic2Fee)
          : (isSlot2 ? schedule.clinicFeeSlot2 : schedule.clinicFee);
      console.log("selectedFee 1 : ",selectedFee)

      this.setState(
        {
          preview: true,
          loading: false,
          apType: this.type,
          orderDetail: {
            ret: {
              appointment_time: this.state.selectedTime,
              duration: this.state.selectedDuration,
              appointment_type: 'clinic',
              clinic_type: this.state.selectedClinic,
              consultation_charges: Number(selectedFee),
            },
          },
          sideBar: 'appointment',
        },
        () => {
          document.body.classList.add('toggled-tab')
        }
      )
    }
  }

  callBackOrder = res => {
    if (this.state.apType === 'clinic') {
      this.props.loadPatientProfile()
      const { patient } = this.state
      patient[this.props.getDoctor.profile.field_type.name] =
        this.props.getDoctor.profile._id
      localStorage.setItem('patient', JSON.stringify(patient))
      this.props.loadPatientProfile()
      this.removeBodyClass()
      if (res.status === 200) {
        this.props.setShowSuccessData(true)
        this.props.history.push('/patient/dashboard')
        //this.props.history.push('/patient/appointment-success')
      } else {
        toast(<AlertError message={'Something went wrong.'} />)
      }
    } else {
      this.setState({
        preview: true,
        loading: false,
        orderDetail: res.data,
      })
    }
  }

  callBackOrderLogin = res => {
    // console.log("payNow state ------------------> ", this.state)
    if (this.state.apType === 'clinic') {
      this.props.loadPatientProfile()
      const { patient } = this.state

      patient[this.props.getDoctor.profile.field_type.name] =
        this.props.getDoctor.profile._id
      localStorage.setItem('patient', JSON.stringify(patient))

      this.props.loadPatientProfile()
      this.removeBodyClass()
      if (res.status === 200) {
        this.props.setShowSuccessData(true)
        localStorage.setItem('skipAppointmentModal', 'true')
        this.props.history.push('/patient/dashboard')
        //this.props.history.push('/patient/appointment-success')
      } else {
        toast(<AlertError message={'Something went wrong.'} />)
      }
    } else {
      this.setState(
        {
          loadingPage: false,
          preview: true,
          loading: false,
          orderDetail: res.data,
          sideBar: 'appointment',
        },
        () => {
          document.body.classList.add('toggled-tab')
        }
      )
    }
  }

  setPatient = data => {
    this.setState({ patient: data })
  }
  changePreview = preview => {
    this.setState({ preview })
  }

  renderClinicCard = (clinic_details) => {
    if (!clinic_details) return null;
    return (
      <ul class='pcb-query-list'>
        <a
          href={clinic_details.googleProfile}
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
        >
          <li>
            {(clinic_details.name || clinic_details.city) && 
            <div class='pcb-query-icon'>
              <img src={locationImg} alt='' />
            </div>
            }
            <div class='pcb-query-text'>
              <h6>
                {clinic_details.name?.trim()
                  ? clinic_details.name
                  : [clinic_details.city, clinic_details.state, clinic_details.zipcode]
                      .filter(Boolean)
                      .join(', ')}
              </h6>

              {clinic_details.name?.trim() && (
                <p>
                  {[clinic_details.address, clinic_details.city, clinic_details.state, clinic_details.zipcode]
                    .filter(Boolean)
                    .join(', ')}
                </p>
              )}
            </div>
          </li>
        </a>

        {clinic_details.phone && (
          <li class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="pcb-query-icon">
                <img src="include/images/feather-phone-call.svg" alt="" />
              </div>
              <div class="pcb-query-text">
                <h6>
                  Call{' '}
                  <a href={`tel:+91${clinic_details.phone}`}>
                    +91-{clinic_details.phone}
                  </a>
                </h6>
              </div>
            </div>

            <div>
              {clinic_details.googleProfile && (
                <a
                  href={clinic_details.googleProfile}
                  target="_blank"
                  rel="noopener noreferrer"
                  class="get-direction-link"
                >
                  Get Directions
                </a>
              )}
            </div>
          </li>
        )}
      </ul>
    );
  };

  toggleShareModal = () => {
    this.setState(prevState => ({
      showShareModal: !prevState.showShareModal,
    }))
  }

  render() {
    const { constants, blogCategory, blog } = this.props.getMisc
    const {
      helpline_no,
      header_email_address,
      footer_email_address,
      facebook,
      instagram,
      twitter,
    } = constants
    const {
      _id,
      documents_url,
      image_url,
      name,
      graduation,
      post_graduation,
      field_type,
      total_experience,
      practice_preferences,
      clinic_details,
      clinic_details_2,
      schedules,
      associations,
      award,
      publication,
      certification,
      super_speciality,
      social_links,
      experiences
    } = this.props.getDoctor.profile
    const patientData =
      field_type?.name === 'Psychologist'
        ? this.props.getPatient.psychologist
        : this.props.getPatient.psychiatrist
// console.log("this.props.getDoctor.profile : ",this.props.getDoctor.profile)
    // const home = blog
    // .filter((i) => i.published === true && i.page === this.props.match.params.username)
    // .slice(0, 3);
    const home = blog.filter(item => 
      item.published === true && item.doctors.some(doctor => doctor.user_name === this.props.match.params.username)
    ) .slice(0, 3)

    const isProduction = process.env.REACT_APP_MODE === "production";
    const profileFeedback = this.props.getFeedback?.profileFeedback

    return (
      <>
        <Helmet>
          <title>
            {`Best ${field_type?.name || "Specialist"} in ${clinic_details?.city || "India"} | Consult Online | Consult In-Clinic with ${name || "Doctor"} - YesMindy`}
          </title>

          <meta
            name="description"
            content={`Consult ${name || "Doctor"}, ${field_type?.name || "Specialist"} with ${total_experience|| "many"} years experience in ${clinic_details?.city || "India"}. Book online consultation for Anxiety, Depression, OCD, Bipolar, Schizophrenia, Workplace Stress, and Panic disorders.`}
          />

          <meta
            name="keywords"
            content={`Best ${field_type?.name || "Specialist"}, Online Consultation, ${name|| "Doctor"}, ${clinic_details?.city || "India"}, Psychiatrist, Psychologist, Therapy for Anxiety, Depression, OCD, Bipolar, Schizophrenia, Workplace Stress, Panic`}
          />

          <meta name="robots" content={isProduction ? "index, follow" : "noindex, nofollow"} />
          <meta name="googlebot" content={isProduction ? "index, follow" : "noindex, nofollow"} />

          <meta property="og:type" content="profile" />
          <meta property="og:title" content={`Book Online with ${name || "Doctor"} - ${field_type?.name || "Specialist"}`} />
          <meta
            property="og:description"
            content={`Book an appointment with ${name || "Doctor"}, ${field_type?.name || "Specialist"}  in ${clinic_details?.city || "India"}. Specializes in ${practice_preferences?.expertise.join(", ")}.`}
          />
          <meta property="og:url" content={`https://yesmindy.com/dr/${this.props.match.params.username}`} />
          <meta property="og:site_name" content="YesMindy" />
          <meta property="og:image" content={image_url ? `${process.env.REACT_APP_S3URL}${image_url}` : logo} />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content={`Consult ${name || "Doctor"} - ${field_type?.name || "Specialist"}`} />
          <meta
            name="twitter:description"
            content={`Online consultation with ${name || "Doctor"}, ${field_type?.name || "Specialist"}. Book appointment for Anxiety, Depression, OCD, Bipolar, Schizophrenia, Workplace Stress, Panic.`}
          />
          <meta name="twitter:image" content={image_url ? `${process.env.REACT_APP_S3URL}${image_url}` : logo} />

          <link rel="canonical" href={`https://yesmindy.com/dr/${this.props.match.params.username}`} />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Physician",
              "name": name || "Doctor",
              "medicalSpecialty": field_type?.name || "Specialist",
              "description": practice_preferences?.about_me || `Consult ${name || "Doctor"}, ${field_type?.name || "Specialist"} with ${total_experience || "many"} years of experience.`,
              "address": {
                "@type": "PostalAddress",
                "streetAddress": clinic_details?.address || "",
                "addressLocality": clinic_details?.city || "India",
                "addressRegion": clinic_details?.state || "",
                "postalCode": clinic_details?.zipcode || "",
                "addressCountry": clinic_details?.country || "India"
              },
              "offers": [
                {
                  "@type": "Offer",
                  "price": schedules?.clinicFee || "",
                  "priceCurrency": "INR",
                  "category": "Clinic Consultation"
                },
                {
                  "@type": "Offer",
                  "price": schedules?.onlineFee || "",
                  "priceCurrency": "INR",
                  "category": "Online Consultation"
                }
              ],
              "affiliation": {
                "@type": "MedicalClinic",
                "name": clinic_details?.name || "",
                "url": clinic_details?.googleProfile || ""
              },
              "award": award?.map(a => `${a.title} (${a.year})`) || [],
              "knowsAbout": [
                ...(practice_preferences?.expertise || []),
                ...(practice_preferences?.interest || [])
              ],
              "knowsLanguage": practice_preferences?.language || [],
              "sameAs": [
                social_links?.instagram,
                social_links?.linkedin,
                clinic_details?.googleProfile,
              ].filter(Boolean),
              "availableService": "Online Consultation",
              "url": `https://yesmindy.com/dr/${this.props.match.params.username}`
            })}
          </script>
        </Helmet>
        <LoadingBar color='#621ac0' ref={ref} shadow={true} />
        <Header
          setPatient={this.setPatient}
          helpline_no={helpline_no}
          header_email_address={header_email_address}
          patient={this.state.patient}
        />

        {/* {this.state.sideBar === 'appointment' && ( */}
          <div className='tab-sidebar'>
          {this.state.sideBar === 'appointment' && (
            <div className='side-pannel-box'>
              {this.state.loadingPage ? (
                <h4>Loading ....</h4>
              ) : (
                <>
                  {this.state.preview && (
                    <OrderReview
                      changePreview={this.changePreview}
                      doctorProfile={this.state.doctorProfile}
                      getDoctor={{
                        doctors: { data: [this.props.getDoctor.profile] },
                      }}
                      months={months}
                      orderDetail={this.state.orderDetail}
                      formatAMPM={this.formatAMPM}
                      payNow={this.payNow}
                      clinic={this.state.apType === 'clinic' ? true : false}
                    />
                  )}
                  {this.state.hasAppointment && !this.state.isRescheduling && (
                    <ExistingAppointment
                      changePreview={this.changePreview}
                      doctorProfile={this.state.doctorProfile}
                      getDoctor={{
                        doctors: { data: [this.props.getDoctor.profile] },
                      }}
                      months={months}
                      formatAMPM={this.formatAMPM}
                      appointment={this.state.activeClinicAppointment}
                      clinic={true}
                      onReschedule={this.handleReschedule}
                      removeBodyClass={this.removeBodyClass}
                    />
                  )}

                  {(!this.state.preview &&
                    (!this.state.hasAppointment || this.state.isRescheduling)) && 
                    (
                    <React.Fragment>
                      <div className='tab-sidebar-top d-flex'>
                        {/* <a
                          href='#!'
                          className='close'
                          onClick={e => this.removeBodyClass(e)}>
                          <div className='icon-img'>
                            <img src={arrowtr} alt='' />
                          </div>
                        </a> */}
                        {this.props.getDoctor.profileLoading ? (
                          <h4>Loading ....</h4>
                        ) : (patientData &&
                            patientData._id ===
                              this.props.getDoctor.profile._id) ||
                          (patientData &&
                            Object.keys(patientData).length === 0) ? (
                          <div>
                            <div className="pannel-top-cont">
                              <div className='icon-text2'>
                                <h4>
                                  {this.state.apType === 'clinic'
                                    ? 'Select A Slot For Clinic Visit'
                                    : 'Select A Slot For Video Consult'}
                                </h4>
                              </div>
                              <div className='pannel-top2'>
                                <a
                                  href='#!'
                                  className='close'
                                  onClick={e => this.removeBodyClass(e)}>
                                  <img src={crossIcon} alt='' />
                                </a>
                              </div>
                            </div>
                            <div className='pannel-tab-box'>
                              {!this.state.appointId && (
                                <TypeSwitch
                                  schedules={schedules}
                                  changeSwitch={this.changeSwitch}
                                  loadDate={this.props.loadDate}
                                  apType={this.state.apType}
                                />
                              )} 
                              <DateTimeSelection
                                loading={this.state.loading}
                                apType={this.state.apType}
                                key={
                                  this.state.selectedTime +
                                  this.state.selectedDate
                                }
                                getDoctor={{
                                  doctors: {
                                    data: [this.props.getDoctor.profile],
                                  },
                                }}
                                selectDate={this.selectDate}
                                appointId={this.state.appointId}
                                selectedClinic={this.state.selectedClinic}
                                selectedTime={this.state.selectedTime}
                                selectedDate={this.state.selectedDate}
                                selectedDuration={this.state.selectedDuration}
                                months={months}
                                getAppointment={this.props.getAppointment}
                                changeClinic={this.changeClinic}
                                changeTime={this.changeTime}
                                changeDuration={this.changeDuration}
                                removeBodyClass={this.removeBodyClass}
                                formatAMPM={this.formatAMPM}
                                keyId={1}
                                doSubmit={this.doSubmit}
                              />
                            </div>
                          </div>
                        ) : (
                          <>
                            <div style={{ marginTop: 50 }}>
                              <div className='pb-3'>
                                You already linked with Below doctor
                              </div>
                              <PostAppointment
                                newDoctor={true}
                                type={field_type?.name}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </React.Fragment>
                  )}
                </>
              )}
            </div>
          )}
        </div>
        {/* )} */}

        {!this.props.getDoctor.profile.name &&
          !this.props.getDoctor.profileLoading && (
            <div class='outer-container'>
              <div class='content-container doctor-profile-container'>
                <div class='container container1'>
                  <div class='row'>
                    <div class='col-md-12'>No active profile found</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        {this.props.getDoctor.profile.name && (
          <div class='outer-container'>
            <div class='content-container doctor-profile-container'>
              <div class='container container1'>
                <div class='row'>
                  <div class='col-md-4'>
                    {/* <div class='doc-img border-radius overflow-hidden'>
                      <img
                        src={process.env.REACT_APP_S3URL + image_url}
                        alt=''
                      />
                    </div>{' '} */}
                    <VideoOverlay
                      image_url={image_url}
                      video_url={social_links.video} />
                    {documents_url && (
                      <div class='registration-box d-flex align-items-center'>
                        <img src={imgTick} alt='' />{' '}
                        <span>
                          Registration No. :{' '}
                          {documents_url.registration_license.licence_no}
                        </span>
                      </div>
                    )}
                  </div>
                  <div class='col-md-8'>
                    <div class='doc-intro-box d-flex  justify-content-between'>
                      <div class='doc-intro-desc font-montserrat'>
                        <h5 className='d-flex align-items-center'>
                          <span>{name}</span>

                          <div className='pl-copy-link ml-4'>
                            <a
                              href='#!'
                              onClick={e => {
                                e.preventDefault()
                                this.toggleShareModal()
                              }}
                              aria-label='Share profile'
                              style={{
                                cursor: 'pointer',
                                textDecoration: 'none',
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                // backgroundColor: '#621ac0',
                                backgroundColor: '#ff8000',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                              >
                              <i
                                className='fa-sharp fa-regular fa-share-nodes'
                                style={{
                                  'color': '#fff',
                                  fontSize: '15px',
                                }}
                              ></i>
                            </a>
                          </div>
                        </h5>
                        <h6>
                          {graduation && graduation.education}
                          {post_graduation && ', ' + post_graduation.education}
                          {super_speciality &&
                            super_speciality.education &&
                            ', ' + super_speciality.education}
                        </h6>
                        <h6>{field_type.name}</h6>
                        {/* <h6>`
                          {super_speciality &&
                            super_speciality.education &&
                            super_speciality.education}

                          {super_speciality &&
                          super_speciality.education &&
                          super_speciality.college_university
                            ? " (" + super_speciality.college_university + ")"
                            : ""}
                        </h6> */}
                        <h6>
                          {total_experience} Year{total_experience > 1 && 's'}{' '}
                          Experience
                        </h6>
                        {practice_preferences.language.length > 0 && (
                          <h6>
                            Speaks:{' '}
                            {practice_preferences.language.map((e, i) => (
                              <>
                                <span>{e}</span>
                                {practice_preferences.language.length - 1 !==
                                  i && ', '}
                              </>
                            ))}
                          </h6>
                        )}
                        <div class='d-flex align-items-center'>
                          <div class='location-pin-icon'>
                            <img src={locationImg} alt='' />
                          </div>{' '}
                          <span>{clinic_details.city}</span>
                        </div>
                        {field_type.name === 'Psychiatrist' ||
                        field_type.name === 'Psychologist' ? (
                          <div class='doc-fee-desc'>
                            {schedules.time && (
                              <>
                                {schedules.clinicFee &&
                                schedules.clinicFee > 0 ? (
                                  <div class='d-flex align-items-center'>
                                    {' '}
                                    <strong>Physical Fee:</strong>
                                    <ul class='fee-list d-flex align-items-center'>
                                      <li>₹ {schedules.clinicFee}</li>
                                      <li>{schedules.time} mins</li>
                                    </ul>
                                  </div>
                                ) : (
                                  ''
                                )}
                                {schedules.onlineFee &&
                                schedules.onlineFee > 0 ? (
                                  <div class='d-flex align-items-center'>
                                    {' '}
                                    <strong>Online Fee:</strong>
                                    <ul class='fee-list d-flex align-items-center'>
                                      <li>₹ {schedules.onlineFee}</li>
                                      <li>{schedules.time} mins</li>
                                    </ul>
                                  </div>
                                ) : (
                                  ''
                                )}
                              </>
                            )}
                            <div class='appointment-btn mb-0'>
                              {patientData &&
                              patientData._id &&
                              patientData._id !==
                                this.props.getDoctor.profile._id ? (
                                <>
                                  <div style={{ marginTop: 50 }}>
                                    <div className='pb-3'>
                                      You already linked with Below doctor
                                    </div>
                                    <PostAppointment
                                      newDoctor={true}
                                      type={field_type?.name}
                                    />
                                  </div>
                                </>
                              ) : (schedules.onlineFee || schedules.onlineFeeSlot2) &&
                                (field_type.name === 'Psychiatrist' ||
                                  field_type.name === 'Psychologist') ? (
                                <>
                                  {(!this.props.getPatient.profile[
                                    field_type.name
                                  ] ||
                                    this.props.getPatient.profile[
                                      field_type.name
                                    ] === _id) && (
                                    <a
                                      disabled={
                                        //!this.state.patient ||
                                        this.state[field_type.name] !== '' &&
                                        this.state[field_type.name] === _id
                                      }
                                      href='#!'
                                      class={
                                        //!this.state.patient ||
                                        this.state[field_type.name] !== '' &&
                                        this.state[field_type.name] === _id &&
                                        !this.state.patient
                                          ? 'btn btn-primary disabled '
                                          : 'btn btn-primary'
                                      }
                                      onClick={e => {
                                        this.setState(
                                          {
                                            sideBar: 'appointment',
                                          },
                                          () => {
                                            this.changeBodyClass(
                                              e,
                                              'toggled-tab'
                                            )
                                            this.changeSwitch('online')
                                          }
                                        )
                                      }}>
                                      Book an appointment{' '}
                                    </a>
                                  )}
                                </>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        ) : (
                          <div class='doc-fee-desc'>
                            <div class='appointment-btn mb-0'>
                              <a
                                href='https://wa.me/917042597742' 
                                className='btn btn-primary'
                                target='_blank'
                                rel='noopener noreferrer'>
                                Chat
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                      <div class='stats-box'>
                        <ul class='stats-list'>
                          {award.length > 0 && (
                            <li>
                              <h6>Awards</h6>
                              <p>{award.length}</p>
                            </li>
                          )}
                          {certification.length > 0 && (
                            <li>
                              <h6>Certification</h6>
                              <p>{certification.length}</p>
                            </li>
                          )}
                          {publication.length > 0 && (
                            <li>
                              <h6>Publication</h6>
                              <p>{publication.length}</p>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class='profile-card-container'>
              <div class='container container1'>
                <div class='row'>
                  <div class='col-md-12'>
                    <div class='profile-card-content d-lg-flex flex-lg-wrap'>
                      <div class='pc-content-left'>
                        <div class='profile-card-box border-radius'>
                          <div class='profile-upper'>
                            <h5>A LITTLE ABOUT ME
                            <span class="ml-2">
                              {social_links.instagram && (<a href={social_links.instagram} target="_blank" rel="noopener noreferrer" class="ml-3">
                                <img src="/social/instagram.svg" alt="Instagram" width="30" height="30" />
                              </a>)}
                              {social_links.linkedin && (<a href={social_links.linkedin} target="_blank" rel="noopener noreferrer" class="ml-3">
                                <img src="/social/linkedin (1).svg" alt="LinkedIn" width="30" height="30" />
                              </a>)}
                            </span>
                            </h5>
                            <p>
                              Hello, I am {name} and I am a {field_type.name}{' '}
                              currently practicing from {clinic_details.city}{' '}
                              with {total_experience} years of experience. I am
                              a trained teleconsultant and use technology along
                              with my clinical acumen for effective results.
                            </p>
                            <p>{practice_preferences.message_to_patient}</p>
                            <p>{practice_preferences.about_me}</p>
                          </div>
                          {practice_preferences.therapy &&
                            practice_preferences.therapy.length > 0 && (
                              <div class='profile-mid'>
                                <h5>Preferred Therapy Mode</h5>
                                {practice_preferences.therapy.map(e => (
                                  <p>{e}</p>
                                ))}
                              </div>
                            )}
                          <div class='profile-lower font-montserrat d-flex align-items-center justify-content-center'>
                            <h4>
                              <a href='#!'>
                                {process.env.REACT_APP_BASEURL +
                                  'dr/' +
                                  this.props.match.params.username}
                              </a>
                            </h4>
                            <div class='pl-copy-link'>
                              <CopyToClipboard
                                text={
                                  process.env.REACT_APP_BASEURL +
                                  'dr/' +
                                  this.props.match.params.username
                                }
                                onCopy={() =>
                                  toast(
                                    <AlertSuccess message={'Link Copied to Clipboard'} />
                                  )
                                }>
                                <a href='#!' onClick={e => e.preventDefault()}>
                                  <img src={copyImg} alt='' />
                                </a>
                              </CopyToClipboard>
                            </div>
                          </div>
                        </div>
                        {clinic_details.city && (
                          <div class='profile-card-box border-radius'>
                            <div class='pcb-head'>
                              <h5>CLINIC ADDRESS</h5>
                            </div>
                            <div class='pcb-body'>
                              {this.renderClinicCard(clinic_details)}
                              {clinic_details_2 && !clinic_details_2.is_available && (
                                <>
                                  {this.renderClinicCard(clinic_details_2)}
                                </>
                              )}
                              {/* <div class='pcb-body'>
                                <ul class='pcb-query-list'>
                                <a 
                                  href={clinic_details.googleProfile} 
                                  target="_blank" 
                                  rel="noopener noreferrer" 
                                  class="text-decoration-none">
                                  <li>
                                    <div class='pcb-query-icon'>
                                      <img src={locationImg} alt='' />
                                    </div>
                                    <div class='pcb-query-text'>
                                      <h6>
                                        {clinic_details.name
                                          ? clinic_details.name
                                          : clinic_details.city +
                                            ', ' +
                                            clinic_details.state +
                                            ' - ' +
                                            clinic_details.zipcode}
                                      </h6>
                                      {clinic_details.name && (
                                        <p>
                                          {clinic_details.address +
                                            ', ' +
                                            clinic_details.city +
                                            ', ' +
                                            clinic_details.state +
                                            ' - ' +
                                            clinic_details.zipcode}
                                        </p>
                                      )}
                                    </div>
                                  </li>
                                  </a>
                                  {clinic_details.phone && (
                                  <li class="d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center">
                                      <div class="pcb-query-icon">
                                        <img src="include/images/feather-phone-call.svg" alt="" />
                                      </div>
                                      <div class="pcb-query-text">
                                        <h6>
                                          Call{' '}
                                          <a href={`tel:+91${clinic_details.phone}`}>
                                            +91-{clinic_details.phone}
                                          </a>
                                        </h6>
                                      </div>
                                    </div>
                                    <div>
                                      {clinic_details.googleProfile && (<a 
                                        href={clinic_details.googleProfile} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        class="get-direction-link">
                                        Get Directions
                                      </a>)}
                                    </div>
                                  </li>
                                )}
                                </ul>
                              </div> */}
                            </div>
                          </div>
                        )}
                        {experiences.length > 0 && (
                          <div class='profile-card-box border-radius'>
                            <div class='pcb-head'>
                              <h5>PAST EXPERIENCES</h5>
                            </div>
                            <div class='pcb-body'>
                              <ul>
                                {experiences.map(e => (
                                  <li><h6>{e.work_place}</h6></li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        )}
                        {associations.length > 0 && (
                          <div class='profile-card-box border-radius'>
                            <div class='pcb-head'>
                              <h5>I’M AFFILIATED WITH </h5>
                            </div>
                            <div class='pcb-body'>
                              <ul>
                                {associations.filter(
                                  e => e.associationstype === 'Hospital'
                                ).length > 0 && (
                                  <li>
                                    <h6>Hospitals</h6>
                                    {associations
                                      .filter(
                                        e => e.associationstype === 'Hospital'
                                      )
                                      .map(ed => (
                                        <p>{ed.associationsvalue}</p>
                                      ))}
                                  </li>
                                )}
                                {associations.filter(
                                  e => e.associationstype === 'Organisation'
                                ).length > 0 && (
                                  <li>
                                    <h6>Organisations</h6>
                                    {associations
                                      .filter(
                                        e =>
                                          e.associationstype === 'Organisation'
                                      )
                                      .map(ed => (
                                        <p>{ed.associationsvalue}</p>
                                      ))}
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        )}
                      </div>

                      <div class='pc-content-right'>
                        {practice_preferences.interest.length > 0 && (
                          <div class='profile-card-box border-radius'>
                            <div class='pcb-head'>
                              <h5>AREAS OF INTEREST</h5>
                            </div>
                            <div class='pcb-body'>
                              <ul>
                                {practice_preferences.interest.map(e => (
                                  <li>{e}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        )}

                        {practice_preferences.expertise.length > 0 && (
                          <div class='profile-card-box border-radius'>
                            <div class='pcb-head'>
                              <h5>I SPECIALIZE IN</h5>
                            </div>
                            <div class='pcb-body'>
                              <ul>
                                {practice_preferences.expertise.map(e => (
                                  <li>{e}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        )}
                        {award.length > 0 && (
                          <div class='profile-card-box border-radius'>
                            <div class='pcb-head'>
                              <h5>AWARDS</h5>
                            </div>
                            <div class='pcb-body'>
                              <ul class='award-list'>
                                {award.map(e => (
                                  <li>
                                    <div class='award-img-box'>
                                      <img src={awLogo} alt='' />
                                    </div>
                                    <div class='award-text-desc'>
                                      <h6>{e.title}</h6>
                                      <p>{e.year}</p>
                                    </div>
                                  </li>
                                ))}
                              </ul>{' '}
                              {/* <a href="#!" class="showall-btn">
                              Show all
                            </a> */}
                            </div>
                          </div>
                        )}

                        {publication.length > 0 && (
                          <div class='profile-card-box border-radius'>
                            <div class='pcb-head'>
                              <h5>I’VE PUBLISHED</h5>
                            </div>
                            <div class='pcb-body'>
                              <ul>
                                {publication.map(e => (
                                  <li>
                                    <h6>{e.title}</h6>
                                    <p>
                                      {e.journal}({e.year})
                                    </p>
                                  </li>
                                ))}
                              </ul>{' '}
                              {/* <a href="#!" class="showall-btn">
                              Show all
                            </a> */}
                            </div>
                          </div>
                        )}
                        {certification.length > 0 && (
                          <div class='profile-card-box border-radius'>
                            <div class='pcb-head'>
                              <h5>CERTIFICATIONS</h5>
                            </div>
                            <div class='pcb-body'>
                              <ul class='award-list'>
                                {certification.map(e => (
                                  <li>
                                    <div class='award-text-desc'>
                                      <h6>{e.title}</h6>
                                      <p>{e.place} - {e.year}</p>
                                    </div>
                                  </li>
                                ))}
                              </ul>{' '}
                              {/* <a href="#!" class="showall-btn">
                              Show all
                            </a> */}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {profileFeedback?.length > 0 && (
              <>
              <div className='content-container'>
                <div className='container container1'>
                  <div className='row'>
                    <div className='col-xl-10 offset-xl-1 text-center'>
                    <div class='dr_article'>
                      <h3>Testimonials</h3>
                    </div>
                      <Swiper
                        modules={[Autoplay, Pagination, Navigation]}
                        loop={true}
                        speed={600}
                        spaceBetween={20}
                        pagination={{ clickable: true, dynamicBullets: true }}
                        navigation={true}
                        autoplay={{
                          delay: 1200,
                          disableOnInteraction: false,
                          pauseOnMouseEnter: true,
                        }}
                        breakpoints={{
                          0:   { slidesPerView: 1 },
                          579: { slidesPerView: 2 },
                          768: { slidesPerView: 3 },
                          991: { slidesPerView: 4 },
                        }}
                      >
                        {profileFeedback.map((e, i) => (
                          <SwiperSlide key={e._id || i}>
                            <div
                              className="testimonial-card"
                              onClick={() =>
                                this.setState({
                                  showFeedbackModal: true,
                                  selectedFeedback: e,
                                })
                              }
                            >
                              <div className="testimonial-content">
                                <p className="testimonial-feedback">
                                  <i>"{e.feedback}"</i>
                                </p>
                                <span className="view-full-review ">
                                  View Full Review →
                                </span>
                              </div>

                              <div className="testimonial-footer">
                                <span className="testimonial-location">
                                  {e.patient_id?.city}, {e.patient_id?.state}
                                </span>

                                <span className="testimonial-date">
                                {moment(e.appointment_id?.appointment_time)
                                  .subtract({
                                    hours: 5,
                                    minutes: 30,
                                  })
                                  .format("DD-MM-YYYY")}
                                </span>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper> 
                    </div>
                  </div>
                </div>
              </div>
              {this.state.showFeedbackModal && (
                <div className="feedback-modal-overlay">
                  <div className="feedback-modal">
                    <button
                      className="close-btn"
                      onClick={() =>
                        this.setState({
                          showFeedbackModal: false,
                          selectedFeedback: null,
                        })
                      }
                    >
                      x
                    </button>

                    <h5>Patient Feedback</h5>

                    <p className="testimonial-feedback">
                      <i>{this.state.selectedFeedback?.feedback}</i>
                    </p>

                    <div className="testimonial-footer">
                      <span className="testimonial-location">
                        Location - {this.state.selectedFeedback?.patient_id?.city},{" "}
                        {this.state.selectedFeedback?.patient_id?.state}
                      </span>

                      <span className="testimonial-date">
                        Appointment Date - {moment(
                          this.state.selectedFeedback?.appointment_id?.appointment_time
                        )
                        .subtract({
                          hours: 5,
                          minutes: 30,
                        })
                        .format("DD-MM-YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              </>
            )}
            {home.length > 0 && (
            <div class='dr_article'>
            <h3>ARTICLES</h3>
            </div>
            )}
            </div>
            {home.length > 0 && (<Blog blog={home} customSize="small" />)}
          </div>
        )}
 
      <ShareProfile
        name={name}
        username={this.props.match.params.username}
        showShareModal={this.state.showShareModal}
        toggleShareModal={this.toggleShareModal}
      />
        <Footer
          footer_email_address={footer_email_address}
          facebook={facebook}
          instagram={instagram}
          twitter={twitter}
        />
        <div className='overlay' onClick={e => this.removeBodyClass(e)}></div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  getMisc: getMisc(state),
  getDoctor: getDoctor(state),
  getAppointment: getAppointment(state),
  getPatient: getPatient(state),
  getFeedback: getFeedback(state),
})

const mapDispatchToProps = dispatch => ({
  loadBlog: () => dispatch(loadBlog()),
  loadSlot: (drId, date, type, duration, clinic) => dispatch(loadSlot(drId, date, type, duration, clinic)),
  clearSlot: () => dispatch(clearSlot()),
  rescheduleAppointment: (id, data, callback) =>
    dispatch(rescheduleAppointment(id, data, callback)),
  createOrder: (data, callback) => dispatch(createOrder(data, callback)),
  updateOrder: (data, callback) => dispatch(updateOrder(data, callback)),
  loadPatientProfile: (callback = null) =>
    dispatch(loadPatientProfile(callback)),

  loadDate: () => dispatch(loadDate()),
  loadConstant: () => dispatch(loadConstant()),
  loadDoctorProfileByUsername: userName =>
    dispatch(loadDoctorProfileByUsername(userName)),
  setAppointmentObjData: data => dispatch(setAppointmentObjData(data)),
  setShowSuccessData: param => dispatch(setShowSuccessData(param)),
  loadProfileFeedback: id => dispatch(loadProfileFeedback(id)),
  checkActiveClinicAppointment: (patientId, doctorId, callback) => dispatch(checkActiveClinicAppointment(patientId, doctorId, callback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
